import { ReportCategory } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

export const AdminReportCategory = {
  addReportCategoryService: async (bodyData) => {
    try {
      const payload = {
        ...ReportCategory.addReportCategory,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getReportCategoryService: async ({ reportCategoryId }) => {
    try {
      const payload = {
        ...ReportCategory.getReportCategory(reportCategoryId),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  updateReportCategoryService: async ({ reportCategoryId, bodyData }) => {
    try {
      const payload = {
        ...ReportCategory.updateReportCategory(reportCategoryId),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  deleteReportCategoryService: async ({ deleteId }) => {
    try {
      const payload = {
        ...ReportCategory.deleteReportCategory(deleteId),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  GetAllReportCategoryService: async ({ queryParams }) => {
    try {
      const payload = {
        ...ReportCategory.getReportCategories,
        queryParams,
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
};
